export const environment = {
  production: true,
  baseHref: '',
  baseUrl: 'cheetah/api/',
  baseChirpUrl: 'chirp/api/',
  baseGoatUrl: 'goat/api/',
  releaseName: 'release-3.5.3-620',
  buildNumber: '0567a0da4d-',
};
